import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import { TransferListing } from "@/modules/transfer-market/entity";
import NavBarMenu from "@/modules/transfer-market/pages/NavBarMenu.vue";
import ListingTable from "@/modules/transfer-market/components/ListingTable.vue";
import QueryPaginator from "@/modules/vue/components/QueryPaginator.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {
    const query = ref(TransferListing.createQueryBuilder('listing').innerJoinAndSelect('listing.player', 'player').innerJoinAndSelect('player.country', 'country').innerJoinAndSelect('player.team', 'team').innerJoinAndSelect('team.country', 'teamCountry').leftJoinAndSelect('listing.offers', 'offer').where('team.user = true'));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: "",
        "no-content-padding": ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('my_listings')), 1)]),
        submenu: _withCtx(({
          route
        }) => [_createVNode(NavBarMenu)]),
        default: _withCtx(() => [_createVNode(QueryPaginator, {
          query: query.value,
          class: "mt-2"
        }, {
          default: _withCtx(({
            items
          }) => [_createVNode(ListingTable, {
            listings: items
          }, null, 8, ["listings"])]),
          _: 1
        }, 8, ["query"])]),
        _: 1
      });
    };
  }
});